import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { AEMContent, Card, Heading } from '@mlc/web-ui-toolkit';
import CommonIds from '../../../common/Common.elements';
import { ScreenSize } from '../../../../enums';
import styled from 'styled-components';

const InactiveAccount = () => {
	return (
		<CardWrapper
			border="mlcBorderThin"
			borderColor="mlcOrange"
			containerSize="thick"
			marginBottom={9}
			display="flex"
			data-id={CommonIds.inactiveAccount}
		>
			<FontAwesomeIcon
				icon={faInfoCircle}
				size="lg"
				style={{ marginTop: '5px', marginRight: '15px' }}
			/>
			<div>
				<Heading el="h2" fontSize="little">
					Your account is inactive
				</Heading>
				<AEMContent path="/secure/_content/Adviser/epi/inactive-account" />
			</div>
		</CardWrapper>
	);
};

export default InactiveAccount;

const CardWrapper = styled(Card)`
	padding: 30px;
	@media (max-width: ${ScreenSize.small}) {
		padding: 20px;
	}
`;
